export const themeContext = "wx-theme";
//# sourceMappingURL=index.js.map